import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
    CompaniesState, initialState
} from "../reducers";

export const selectCompaniesState = createFeatureSelector<CompaniesState>("companies");

export const selectFilters = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => (state ? state.filters : initialState)
);
